<template>
  <div class="bg-white">
    <b-modal id="stripeCheckoutModal" :title="stripeCheckoutModalData.title" centered hide-footer :header-text-variant="'gray'">
      <div class="d-block text-center">
        {{ stripeCheckoutModalData.message }}
      </div>

      <b-button
        variant="primary"
        style="width: fit-content; margin-top: 2em"
        class="btn-block"
        @click="
          () => {
            this.$bvModal.hide('stripeCheckoutModal');
          }
        ">
        Close
      </b-button>
    </b-modal>
    <!-- Header -->
    <b-navbar v-if="!errorLoadingCompany" type="dark" variant="secondary" class="p-2 sticky border-bottom-1" sticky>
      <span class="navbar-brand">
        <img v-if="company.logoUrl" :src="company.logoUrl" />
      </span>
    </b-navbar>
    <section v-if="errorLoadingCompany" class="py-6 bg-white">
      <div class="container">
        <div class="row row-grid align-items-center">
          <span class="text-center navbar-brand">
            <h1>Invalid URL</h1>
          </span>
        </div>
      </div>
    </section>

    <!-- Page content -->

    <div v-else style="position: relative" class="container py-4 bg-white">
      <div style="display: flex; flex-direction: column; gap: 1em">
        <span>Please provide the following initial configuration information for your Mobile Application.</span>
        <span>When you are satisfied with your entries click 'Submit' to initiate the automatic build process.</span>
      </div>

      <i style="font-size: smaller; color: grey">
        <span>Personal details entered here are kept securely and in strict confidence under the provisions of our Privacy Policy.</span>
        <span>&nbsp; Fields marked with * are required.</span>
      </i>

      <form class="formStyle">
        <div>
          <b-form-group role="group" class="mb-3 has-feedback">
            <label class="form-control-label" for="firstname">First Name *</label>
            <input
              id="firstname"
              v-model.trim="tempProvisioningForm.firstName"
              v-validate="'required'"
              type="text"
              name="firstname"
              data-vv-as="First Name"
              data-vv-name="firstname"
              placeholder="First Name"
              autocomplete="NoAutocomplete"
              class="form-control no-instruction"
              :class="{
                input: true,
                'is-invalid': errors.has('firstname'),
                'has-invalid': errors.has('firstname'),
              }" />
            <div class="invalid-feedback" :is-invalid="errors.has('firstname')">
              {{ errors.first('firstname') }}
            </div>
          </b-form-group>
          <b-form-group role="group" class="mb-3 has-feedback">
            <label class="form-control-label" for="lastname">Last Name *</label>
            <input
              id="lastname"
              v-model.trim="tempProvisioningForm.lastName"
              v-validate="'required'"
              type="text"
              name="lastname"
              data-vv-as="Last Name"
              data-vv-name="lastname"
              placeholder="Last Name"
              autocomplete="NoAutocomplete"
              class="form-control no-instruction"
              :class="{
                input: true,
                'is-invalid': errors.has('lastname'),
                'has-invalid': errors.has('lastname'),
              }" />
            <div class="invalid-feedback" :is-invalid="errors.has('lastname')">
              {{ errors.first('lastname') }}
            </div>
          </b-form-group>
          <b-form-group role="group" class="mb-3 has-feedback">
            <label class="form-control-label" for="email">Email *</label>
            <input
              id="email"
              v-model.trim="tempProvisioningForm.email"
              v-validate="'required|email'"
              type="email"
              name="email"
              data-vv-as="Email"
              data-vv-name="email"
              placeholder="Email"
              autocomplete="NoAutocomplete"
              class="form-control no-instruction"
              :class="{
                input: true,
                'is-invalid': errors.has('email'),
                'has-invalid': errors.has('email'),
              }" />
            <div class="invalid-feedback" :is-invalid="errors.has('email')">
              {{ errors.first('email') }}
            </div>
          </b-form-group>
          <b-form-group role="group" class="mb-3 has-feedback">
            <label class="form-control-label" for="email">Phone *</label>

            <div class="phoneContainer">
              <input id="left" v-model="dialCode" placeholder="+1" type="text" disabled name="countryCode" class="form-control no-instruction" />
              <input
                v-model.trim="tempProvisioningForm.phone"
                v-validate="{
                  required: true,
                  phone: [dialCode],
                }"
                type="text"
                name="phone"
                data-vv-as="Cellphone Number"
                data-vv-name="phone"
                placeholder="Cellphone Number"
                class="form-control no-instruction"
                autocomplete="NoAutocomplete"
                :class="{
                  input: true,
                  'is-invalid': errors.has('phone'),
                  'has-invalid': errors.has('phone'),
                }" />
              <div class="invalid-feedback" :is-invalid="errors.has('phone')">
                {{ errors.first('phone') }}
              </div>
            </div>
          </b-form-group>
          <b-form-group role="group" class="mb-3 has-feedback" v-if="provisioningForm.requirePassword">
            <label class="w-100 form-control-label" for="password"
              >Password
              <small v-if="passwordShow" class="pull-right mr-1"
                ><a><i class="text-gray" :class="iconType.password" @click="switchVisibility('password')"></i></a></small
            ></label>
            <input
              id="newPassword"
              v-model.trim="tempProvisioningForm.password"
              v-validate="'required'"
              :type="passwordFieldType.password"
              name="newPassword"
              data-vv-as="password"
              data-vv-name="password"
              data-vv-delay="1000"
              placeholder="Enter password"
              class="form-control no-instruction"
              :class="{
                input: true,
                'is-invalid': errors.has('password'),
                'has-invalid': errors.has('password') || (tempProvisioningForm.password.length > 0 && progressWidth <= 40),
                'has-valid': progressWidth >= 75 && hasLowercaseUppercase && hasNumber && hasSpecialChar,
                'has-warning': tempProvisioningForm.password.length > 0 && progressWidth > 40 && progressWidth < 75,
              }"
              @input="passwordCheck" />
            <span class="has-icon-feedback"></span>
            <div class="invalid-feedback" :is-invalid="errors.has('password')">
              {{ errors.first('password') }}
            </div>
          </b-form-group>
          <b-col v-if="provisioningForm.requirePassword" lg="12" md="12" class="order-md-last text-default strong">
            <small class="font-weight-bold">Your password must not contain any blank spaces and meet the following criteria:</small>
            <ul class="list-icon pt-3">
              <li
                :class="{
                  'icon-check-circle-o muted': tempProvisioningForm.password.length == 0,
                  'icon-check-circle valid': tempProvisioningForm.password.length >= 8,
                  'icon-warning invalid': tempProvisioningForm.password.length < 8 && tempProvisioningForm.password.length > 0,
                }">
                8 characters
              </li>
              <li
                :class="{
                  'icon-check-circle-o muted': hasLowerCase === false && hasUpperCase === false,
                  'icon-exclamation-circle warning': (!hasLowerCase && hasUpperCase) || (hasUpperCase === false && hasLowerCase),
                  'icon-check-circle valid': hasLowercaseUppercase,
                  'icon-warning invalid': hasLowercaseUppercase === false && tempProvisioningForm.password.length > 0,
                }">
                Uppercase and lowercase letters
              </li>
              <li
                :class="{
                  'icon-check-circle-o muted': tempProvisioningForm.password.length == 0,
                  'icon-check-circle valid': hasNumber,
                  'icon-warning invalid': !hasNumber && tempProvisioningForm.password.length > 0,
                }">
                Number(s)
              </li>
              <li
                :class="{
                  'icon-check-circle-o muted': tempProvisioningForm.password.length == 0,
                  'icon-check-circle valid': hasSpecialChar,
                  'icon-warning invalid': !hasSpecialChar && tempProvisioningForm.password.length > 0,
                }">
                Special character(s)
              </li>
            </ul>
            <div class="progress">
              <div
                class="progress-bar passwordMeter"
                role="progressbar"
                :style="{
                  width: progressWidth + '%',
                }"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100">
                {{ progressLabel }}
              </div>
            </div>
          </b-col>
          <b-form-group v-if="provisioningForm.requirePassword" role="group" class="mb-3 has-feedback">
            <label class="w-100 form-control-label" for="confirmPassword">Confirm Password</label>
            <input
              v-model.trim="tempProvisioningForm.confirmPassword"
              v-validate="`required|confirmPassword:${tempProvisioningForm.password}`"
              type="password"
              name="confirmPassword"
              data-vv-as="password confirmation"
              placeholder="Re-enter password"
              class="form-control no-instruction"
              data-vv-name="confirmPassword"
              data-vv-delay="1000"
              :class="{
                input: true,
                'is-invalid': errors.has('confirmPassword'),
                'has-invalid': errors.has('confirmPassword'),
                'has-valid': !errors.has('confirmPassword') && tempProvisioningForm.confirmPassword.length >= 8,
              }" />
            <span class="has-icon-feedback"></span>
            <div class="invalid-feedback" :is-invalid="errors.has('confirmPassword')">
              {{ errors.first('confirmPassword') }}
            </div>
          </b-form-group>
        </div>
        <div>
          <b-form-group role="group" class="mb-3 has-feedback">
            <label class="form-control-label" for="appName">App Name *</label>
            <input
              id="appName"
              v-model.trim="tempProvisioningForm.appName"
              v-validate="'required'"
              type="text"
              name="appName"
              data-vv-as="App Name"
              data-vv-name="appName"
              placeholder="App Name"
              autocomplete="NoAutocomplete"
              class="form-control no-instruction"
              :class="{
                input: true,
                'is-invalid': errors.has('appName'),
                'has-invalid': errors.has('appName'),
              }" />
            <div class="invalid-feedback" :is-invalid="errors.has('appName')">
              {{ errors.first('appName') }}
            </div>
          </b-form-group>
          <b-form-group v-if="provisioningForm.renderAppLogo" role="group" class="mb-3 has-feedback">
            <div style="width: 100%; display: flex; justify-content: space-between">
              <label class="form-control-label" for="appLogo">App Logo </label>
              <a v-b-tooltip.hover class="btn btn-sm text-danger" :title="provisioningForm.appLogoHint">
                <span class="btn-inner--icon"><i class="fas fa-question-circle text-muted pull-right"></i></span>
              </a>
            </div>
            <b-form-file
              id="appLogo"
              v-model="tempProvisioningForm.appLogo"
              :state="!errors.has('appLogo')"
              :class="{
                hidden: appLogoUrl,
              }"
              class="uploadIcon"
              accept="image/png, image/jpeg"
              placeholder="Choose or Drag app logo here..."
              name="appLogo"
              drop-placeholder="Drop app logo here..."
              :hint="provisioningForm.appLogoHint"
              @change="logoFileChange($event)" />
            <div v-if="appLogoUrl" class="appIconContainer" style="background: #e9ecef !important; border: 2px solid #607d8b !important`">
              <a class="upload-image-link" onclick="document.getElementById('appLogo').click()">
                <div class="upload-image-overlay">Choose image here...</div>
                <img v-if="appLogoUrl" :src="appLogoUrl" class="mw-100 mx-auto image-preview" />
              </a>
            </div>
          </b-form-group>
          <b-form-group v-if="provisioningForm.renderAppImage" role="group" class="mb-3 has-feedback">
            <div style="width: 100%; display: flex; justify-content: space-between">
              <label class="form-control-label" for="appImage">App Image </label>
              <a v-b-tooltip.hover class="btn btn-sm text-danger" :title="provisioningForm.appImageHint">
                <span class="btn-inner--icon"><i class="fas fa-question-circle text-muted pull-right"></i></span>
              </a>
            </div>
            <b-form-file
              id="appImage"
              v-model="tempProvisioningForm.appImage"
              :state="!errors.has('appImage')"
              :class="{
                hidden: appImageUrl,
              }"
              class="uploadIcon"
              accept="image/png, image/jpeg"
              placeholder="Choose or Drag app image here..."
              name="appImage"
              drop-placeholder="Drop app image here..."
              :hint="provisioningForm.appImageHint"
              :disabled="!provisioningForm.renderAppImage"
              @change="imageFileChange($event)" />
            <div v-if="appImageUrl" class="appIconContainer" style="background: #e9ecef !important; border: 2px solid #607d8b !important`">
              <a class="upload-image-link" onclick="document.getElementById('appImage').click()">
                <div class="upload-image-overlay">Choose image here...</div>
                <img v-if="appImageUrl" :src="appImageUrl" class="mw-100 mx-auto image-preview" />
              </a>
            </div>
          </b-form-group>
          <b-form-group v-if="provisioningForm.renderAppDescription" role="group" class="mb-3 has-feedback">
            <div style="width: 100%; display: flex; justify-content: space-between">
              <label class="form-control-label" for="appDescriptionHint">App Description </label>
              <a v-b-tooltip.hover class="btn btn-sm text-danger" :title="provisioningForm.appDescriptionHint">
                <span class="btn-inner--icon"><i class="fas fa-question-circle text-muted pull-right"></i></span>
              </a>
            </div>
            <ckeditor id="appDescription" v-model="tempProvisioningForm.appDescription" :editor="editor" :config="editorConfig"></ckeditor>
          </b-form-group>
        </div>

        <button
          v-promise-btn
          type="button"
          class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
          @click="fireSubmitProvisioningForm"
          :disabled="errors.any('register') || submitLoading">
          Submit
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import * as Cookie from 'js-cookie';
import { Validator } from 'vee-validate';
import { phoneRule } from '@/utils/veeValidateRules';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import { API_URL } from '@/api/constants/baseUrl';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import List from '@ckeditor/ckeditor5-list/src/list';
import Font from '@ckeditor/ckeditor5-font/src/font';
import BlockToolbar from '@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar';
import HeadingButtonsUI from '@ckeditor/ckeditor5-heading/src/headingbuttonsui';
import ParagraphButtonUI from '@ckeditor/ckeditor5-paragraph/src/paragraphbuttonui';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import { NotificationTypes, wrapNotification } from '@/utils/notification';
import { resizeImage } from '@/utils/imageResizeUtils';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
import { submitProvisioningForm, hashedIdToProvisioningForm } from '@/api/request/provisioning';
import { getCompanyByCompanyID } from '@/api/request/company';

import { globalStore } from '@/utils/global';

Validator.extend('phone', phoneRule);
const confirmPassword = {
  getMessage: (field) => `The password confirmation does not match`,
  validate(value, param) {
    return new Promise((resolve) => {
      resolve({
        valid: value.toString() === param[0],
        data: value === '' ? { message: `Confirm password field is required` } : '',
      });
    });
  },
};
Validator.extend('confirmPassword', confirmPassword);

Vue.use(Cookie);

const stripeCheckoutModalSuccess = {
  title: 'Payment Successful',
  message: 'You will receive an email confirmation with your new account details.',
};

const stripeCheckoutModalFailed = {
  title: 'Payment Failed',
  message: 'We were unable to process your payment, please check your card and try again.',
};

export default {
  name: 'ProvisioningForm',
  data() {
    return {
      submitLoading: false,
      stripeCheckoutModalData: {
        title: '',
        message: '',
      },
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          EasyImage,
          EssentialsPlugin,
          Heading,
          SimpleUploadAdapter,
          BoldPlugin,
          ItalicPlugin,
          BlockQuote,
          Underline,
          LinkPlugin,
          ParagraphPlugin,
          Link,
          List,
          Alignment,
          Indent,
          IndentBlock,
          Font,
          HeadingButtonsUI,
          ParagraphButtonUI,
          Alignment,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          Autoformat,
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'underline',
          'blockQuote',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'outdent',
          'indent',
          '|',
          'undo',
          'redo',
          '|',
          'link',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'alignment:left',
          'alignment:right',
          'alignment:center',
          'alignment:justify',
          '|',
          'imageUpload',
          'imageStyle:side',
          'imageStyle:full',
        ],
        image: {
          toolbar: ['imageTextAlternative', 'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight'],
          styles: ['full', 'side', 'alignLeft', 'alignCenter', 'alignRight'],
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph',
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2',
            },
          ],
        },
        indentBlock: {
          classes: [
            'custom-block-indent-a', // First step - smallest indentation.
            'custom-block-indent-b',
            'custom-block-indent-c', // Last step - biggest indentation.
          ],
        },
        simpleUpload: {
          uploadUrl: `${API_URL}/ckeditor`,
          withCredentials: true,
          headers: {
            Authorization: `${Cookies.get('user-token')}`,
          },
        },
      },
      countryCode: { code: 'us', text: 'United States', value: 1 },
      dialCode: '+1',
      progressWidth: 0,
      progressLabel: '',
      hasNumber: false,
      hasUpperCase: false,
      hasLowerCase: false,
      hasLowercaseUppercase: false,
      hasSpecialChar: false,
      hasPeriodDash: false,
      hasError: false,
      changePasswordError: '',
      passwordShow: false,
      iconType: {
        password: 'far fa-eye',
      },
      passwordFieldType: {
        password: 'password',
      },
      errorLoadingCompany: false,
      company: {
        logoUrl: '',
        companyID: '',
      },
      provisioningForm: {
        _id: '',
        renderAppLogo: true,
        renderAppImage: true,
        renderAppDescription: true,
        requirePassword: true,
        appLogoHint: 'Upload your app logo',
        appImageHint: 'Upload your app image',
        appDescriptionHint: 'Enter your app description',
      },
      appImageUrl: '',
      appLogoUrl: '',
      tempProvisioningForm: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        appName: '',
        appLogo: '',
        appImage: '',
        appDescription: '',
      },
    };
  },
  beforeMount() {
    const hashedID = this.$route.params.companyID;
    const token = Cookie.get('user-token') || globalStore.token;

    this.fetchData(token, hashedID);
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const stripeSuccess = urlParams.get('stripeSuccess');

    if (stripeSuccess === 'true') {
      this.$bvModal.show('stripeCheckoutModal');
      this.stripeCheckoutModalData = stripeCheckoutModalSuccess;
    } else if (stripeSuccess === 'false') {
      this.$bvModal.show('stripeCheckoutModal');
      this.stripeCheckoutModalData = stripeCheckoutModalFailed;
    }
  },
  methods: {
    logoFileChange(e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }
      var reader = new FileReader();
      var self = this;
      reader.addEventListener('load', function (event) {
        var image = event.target;
        self.appLogoUrl = image.result;
      });

      reader.readAsDataURL(file);
    },
    imageFileChange(e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }
      var reader = new FileReader();
      var self = this;
      reader.addEventListener('load', function (event) {
        var image = event.target;
        self.appImageUrl = image.result;
      });

      reader.readAsDataURL(file);
    },
    passwordCheck: function () {
      const password = this.tempProvisioningForm.password;
      this.hasNumber = /\d/.test(password);
      this.hasUpperCase = /[A-Z]/.test(password);
      this.hasLowerCase = /[a-z]/.test(password);
      this.hasLowercaseUppercase = /[a-z]/.test(password) && /[A-Z]/.test(password);
      this.hasSpecialChar = /[!@#/$%^&*)(+=#><;:,._-]/.test(password);
      this.hasPeriodDash = !/^\s*?\.|-.*$/.test(password);
      this.level = 0;

      var progressBar = document.querySelectorAll('.passwordMeter');
      var charCounts = {};
      var numCount = 0;
      var upperCaseCount = 0;
      var specialCharCount = 0;

      for (var i = 0; i < password.length; i++) {
        if (/\d/.test(password.charAt(i))) numCount++;
        if (/[A-Z]/.test(password.charAt(i))) upperCaseCount++;
        if (/[!@#/$%^&*)(+=#><;:,._-]/.test(password.charAt(i))) specialCharCount++;
      }

      charCounts.numCount = numCount;
      charCounts.ucCount = upperCaseCount;
      charCounts.scCount = specialCharCount;

      this.progressWidth = this.calcPassStrength(
        password.length,
        this.hasNumber,
        this.hasLowercaseUppercase,
        charCounts,
        this.hasSpecialChar,
        this.hasPeriodDash
      );

      if (this.progressWidth <= 40) {
        [].forEach.call(progressBar, function (el) {
          el.classList.remove('bg-warning');
          el.classList.remove('bg-success');
          el.classList.add('bg-danger');
        });
        this.progressLabel = this.progressWidth >= 30 ? 'Bad Password' : 'Bad';
        this.$validator.errors.add({
          field: 'password',
          msg: 'Password must meet the criteria',
        });
      } else if (this.progressWidth > 40 && this.progressWidth < 75) {
        [].forEach.call(progressBar, function (el) {
          el.classList.remove('bg-danger');
          el.classList.remove('bg-success');
          el.classList.add('bg-warning');
        });
        this.progressLabel = 'Weak Password';
        this.$validator.errors.add({
          field: 'password',
          msg: 'Password must meet the criteria',
        });
      } else if (this.progressWidth >= 75) {
        [].forEach.call(progressBar, function (el) {
          el.classList.remove('bg-warning');
          el.classList.remove('bg-danger');
          el.classList.add('bg-success');
        });
        this.progressLabel = 'Strong Password';

        this.$nextTick(() => {
          this.$validator.errors.remove('password');
        });
      }
    },
    calcPassStrength: function (len, num, lowCap, charCounts, specialChar, periodDash) {
      var level = 0;
      if (len >= 8) {
        level += 18;
      }
      if (charCounts.ucCount === 2) {
        level += 10;
      }
      if (charCounts.ucCount > 2) {
        level += 4;
      }
      if (num) {
        level += 12;
      }
      if (charCounts.numCount > 2) {
        level += 5;
      }
      if (lowCap) {
        level += 22;
      }
      if (specialChar) {
        level += 23;
      }
      if (charCounts.scCount === 2) {
        level += 10;
      }
      if (charCounts.scCount >= 3) {
        level += 12;
      }
      if (len === 0) {
        level = 0;
      }
      return level;
    },
    switchVisibility(field) {
      this.passwordFieldType[field] = this.passwordFieldType[field] === 'password' ? 'text' : 'password';
      this.iconType[field] = this.iconType[field] === 'far fa-eye' ? 'far fa-eye-slash' : 'far fa-eye';
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async fireSubmitProvisioningForm() {
      this.$validator.validateAll().then(async (result) => {
        console.log('Form submitted', result);
        if (result) {
          let newPhone = `${this.tempProvisioningForm.phone}`;
          if (this.dialCode === '+1') {
            this.tempProvisioningForm.phone = this.tempProvisioningForm.phone.replace(/\s/g, '');
            this.tempProvisioningForm.phone = this.tempProvisioningForm.phone.replace(/[^0-9]/g, '');
            if (this.tempProvisioningForm.phone.length === 10) {
              this.tempProvisioningForm.phone = this.tempProvisioningForm.phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
              newPhone = `${this.dialCode} ${this.tempProvisioningForm.phone}`;
            } else {
              this.$validator.errors.add({
                field: 'phone',
                msg: 'Please enter a valid phone number',
                id: 'phone',
              });
              return false;
            }
          } else {
            this.tempProvisioningForm.phone = this.tempProvisioningForm.phone.replace(/[^0-9]/g, '');
            newPhone = `${this.dialCode} ${this.tempProvisioningForm.phone}`;
          }
          const token = Cookie.get('user-token') || globalStore.token;
          const formData = new FormData();
          formData.append('firstName', this.tempProvisioningForm.firstName);
          formData.append('lastName', this.tempProvisioningForm.lastName);
          formData.append('email', this.tempProvisioningForm.email);
          formData.append('phone', newPhone);
          if (this.provisioningForm.requirePassword) {
            formData.append('password', this.tempProvisioningForm.password);
          }
          formData.append('appName', this.tempProvisioningForm.appName);
          formData.append('appDescription', this.tempProvisioningForm.appDescription);
          if (this.tempProvisioningForm.appLogo != '' && this.tempProvisioningForm.appLogo instanceof File) {
            formData.append('appLogo', await resizeImage(700, 15, this.tempProvisioningForm.appLogo));
          }
          if (this.tempProvisioningForm.appImage != '' && this.tempProvisioningForm.appImage instanceof File) {
            formData.append('appImage', await resizeImage(600, 600, this.tempProvisioningForm.appImage));
          }
          formData.append('provisioningFormID', this.provisioningForm._id);
          submitProvisioningForm(token, formData)
            .then((response) => {
              const url = response.data.url;
              if (!url) {
                if (response.data.error) {
                  wrapNotification(this.$notify, NotificationTypes.Error, response.data.error);
                } else {
                  wrapNotification(this.$notify, NotificationTypes.Error, 'An error occurred while submitting the form');
                }
                return;
              }
              wrapNotification(this.$notify, NotificationTypes.Success, 'Redirecting to checkout');
              window.location.href = url;
            })
            .catch((error) => {
              wrapNotification(this.$notify, NotificationTypes.Error, error.response.data.error);
            });
        }
      });
    },
    async fetchData(token, hashedID) {
      hashedIdToProvisioningForm(token, hashedID)
        .then((response) => {
          if (response.data && response.data.provisioningForm) {
            const data = response.data.provisioningForm;

            this.provisioningForm._id = data._id;
            this.provisioningForm.renderAppLogo = data.renderAppLogo;
            this.provisioningForm.renderAppImage = data.renderAppImage;
            this.provisioningForm.renderAppDescription = data.renderAppDescription;
            this.provisioningForm.appLogoHint = data.appLogoHint;
            this.provisioningForm.appImageHint = data.appImageHint;
            this.provisioningForm.appDescriptionHint = data.appDescriptionHint;
            this.provisioningForm.requirePassword = data.requirePassword;
            const companyID = data.companyID;

            getCompanyByCompanyID(token, companyID)
              .then((response) => {
                if (response.data && response.data.data) {
                  const data = response.data.data;
                  if (Array.isArray(data)) {
                    this.errorLoadingCompany = true;
                    return;
                  }
                  this.company.companyID = data.companyID;
                  this.company.logoUrl = data.logo;
                  this.errorLoadingCompany = false;
                } else {
                  console.log('No data found');
                  this.errorLoadingCompany = true;
                }
              })
              .catch((error) => {
                this.errorLoadingCompany = true;
                console.log(error);
              });
          } else {
            console.log('No data found');
            this.errorLoadingCompany = true;
          }
        })
        .catch((error) => {
          this.errorLoadingCompany = true;
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
.modal-title {
  color: #525f7f !important;
}
.formStyle {
  display: grid;
  padding-block: 1em;
  grid-template-columns: 1fr;
  gap: 1em;
  @media (min-width: 700px) {
    grid-template-columns: 1fr 1fr;
  }
}
.navbar-header {
  float: left;
  padding: 15px;
  text-align: center;
  width: 100%;
}
span.navbar-brand {
  float: none;
  margin: 0 auto;
  text-align: center;
  span {
    color: #000;
  }
  img {
    height: 60px;
  }
}
.border-bottom-1 {
  border-bottom: 1px solid #adb5bd;
}
.phoneContainer {
  display: grid;
  grid-template-columns: 8vh 1fr;

  #left {
    text-align: end;
  }

  .invalid-feedback {
    grid-column: 1 / span2;
  }
}

.progress {
  height: 0.95rem !important;
}
.imageContainer {
  height: 300px;
  position: relative;
  border: 1px solid #bcbcbc;
  border-radius: 7px;
}

.image-preview {
  object-fit: cover;
  width: 200px;
  height: 200px;
  border-radius: 0.375rem;
}

.upload-image-link {
  width: 100%;
  height: 100%;
}

.upload-image-link:hover .upload-image-overlay {
  display: block;
}

.upload-image-overlay {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  text-align: center;
  color: #e5e5e5;
  height: 300px;
  display: none;
  line-height: 300px;
}
.iconContainer {
  height: 80px;
  width: 80px;
  position: relative;
  border: 1px solid #bcbcbc;
  border-radius: 7px;
}

.iconContainer .upload-image-overlay {
  height: 80px;
  width: 80px;
  line-height: 80px;
  font-size: 9px;
}

.appIconContainer {
  position: relative;
  width: fit-content;
  float: right;
}

.uploadIcon .custom-file-label {
  border: 1px solid #bcbcbc !important;
}

.appIconContainer .upload-image-overlay {
  height: 100%;
  width: 100%;
  line-height: 500px;
}
</style>
